/*
 * rheincool — Footer (Footer-Handoff §7/§8/§11)
 * - „Nach oben": window.scrollTo, smooth nur ohne prefers-reduced-motion
 * - Cookie-Einstellungen: öffnet das Consent-Panel erneut (Pflicht)
 * - Tracking: footer_link_click mit Spalte + Label
 */
(() => {
  'use strict';
  if (window.__rcFooter) return;
  window.__rcFooter = true;

  const track = (event, params) => {
    if (window.rcTrack) window.rcTrack(event, params || {});
  };

  document.addEventListener('click', (event) => {
    const top = event.target.closest('[data-back-to-top]');
    if (top) {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
      track('back_to_top_click', { seitentyp: document.body.dataset.template || location.pathname.split('/')[1] || 'home' });
      return;
    }

    const cookie = event.target.closest('[data-cookie-settings]');
    if (cookie) {
      // Fallback (Rechtsseiten-Handoff §4): ohne Consent-Skript navigiert der
      // Link auf /pages/datenschutz#cookies — mit Skript öffnet Ebene 2.
      if (window.__rcConsent) event.preventDefault();
      track('cookie_settings_reopen', { quelle: 'footer' });
      document.dispatchEvent(new CustomEvent('rc:consent:open'));
      return;
    }

    const link = event.target.closest('[data-rc-track="footer_link_click"]');
    if (link) {
      track('footer_link_click', { spalte: link.dataset.rcTrackSpalte, label: link.dataset.rcTrackLabel });
    }
  });

  // Spalten-Akkordeons: Desktop offen, mobil zu — bei Resize nachführen
  const media = window.matchMedia('(max-width: 749px)');
  const applyState = () => {
    document.querySelectorAll('.rc-footer__details').forEach((det) => {
      det.open = !media.matches;
    });
  };
  applyState();
  media.addEventListener('change', applyState);
})();
